export const module = {
  info: {
    name: 'voip-report',
    caption: 'voip report',
    viewGroup: 'status-and-report'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'VOS Reports',
    icon: 'el-icon-files',
    routeName: 'module->voip-report->create',
    children: [
      {
        caption: 'View Report',
        icon: 'el-icon-plus',
        routeName: 'module->voip-report->create'
      },
      {
        caption: 'List Reports',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-report->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
